import React from 'react';
import { Link, useLocation } from 'react-router';
import styled from 'styled-components';
import { buildLoginPath, buildRegisterPath, locationToPath } from '../../utils/authRedirect';

const Wrap = styled.div`
  margin-top: 0.25rem;
  padding: 0.85rem 0;
`;

const Message = styled.p`
  margin: 0 0 0.75rem;
  color: var(--text-secondary);
  font-size: 0.9375rem;
  line-height: 1.45;
`;

const PrimaryLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.65rem 1rem;
  border-radius: 0.375rem;
  border: 2px solid var(--primary-color);
  background: var(--primary-color);
  color: #fff;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
  margin-bottom: 0.65rem;

  &:hover {
    opacity: 0.92;
  }
`;

const SecondaryLine = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-secondary);

  a {
    color: var(--primary-color);
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

/**
 * Auth entry for gated actions: Create Account first, Sign In one click away.
 */
const GuestAuthPrompt = ({
  message = 'Create an account to continue',
  returnTo,
  createLabel = 'Create Account',
  signInPrompt = 'Already have an account?',
  signInLabel = 'Sign In',
}) => {
  const location = useLocation();
  const next = returnTo || locationToPath(location) || '/';

  return (
    <Wrap>
      <Message>{message}</Message>
      <PrimaryLink to={buildRegisterPath(next, { requireAuth: true })}>
        {createLabel}
      </PrimaryLink>
      <SecondaryLine>
        {signInPrompt}{' '}
        <Link to={buildLoginPath(next)}>{signInLabel}</Link>
      </SecondaryLine>
    </Wrap>
  );
};

export default GuestAuthPrompt;
